var _defs, _circle, _circle2, _circle3, _path, _polygon, _polygon2, _path2, _polygon3, _polygon4, _path3, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.11 143.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{stroke:#000;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 71.56,
    cy: 71.55,
    r: 71.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 71.56,
    cy: 71.55,
    r: 71.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.56,
    cy: 71.56,
    r: 65.93
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.55,54.92H87.28c2.84-14.37-4.89-19.27-12.34-21l.26,0a5.64,5.64,0,0,0-2.65-4.46,1.83,1.83,0,0,0,.6-1.47,1.57,1.57,0,0,0-.76-1.51V24.25a1,1,0,0,0,.31-.77.9.9,0,0,0-.31-.74V20.4h-.1a1,1,0,0,0,.41-.85,8.74,8.74,0,0,0-1.15-3,8.75,8.75,0,0,0-1.15,3,1,1,0,0,0,.4.85h-.1v2.35a.91.91,0,0,0-.31.74,1,1,0,0,0,.31.77v2.28A1.57,1.57,0,0,0,70,28a1.81,1.81,0,0,0,.6,1.47A5.64,5.64,0,0,0,67.91,34l.26,0c-7.73,1.76-15.18,9.44-12.34,21Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.36 79.7 53.19 79.7 51.92 80.43 51.92 83.1 53.19 83.83 53.36 83.83 54.85 83.83 71.56 83.83 88.26 83.83 89.75 83.83 89.91 83.83 91.19 83.1 91.19 80.43 89.91 79.7 89.75 79.7 88.22 79.7 71.56 79.7 54.88 79.7 53.36 79.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "92.93 102.06 90.05 102.06 88.42 102.06 85.45 102.06 78.13 102.06 75.22 102.06 71.56 102.06 67.89 102.06 64.98 102.06 57.65 102.06 54.69 102.06 53.06 102.06 50.17 102.06 50.17 100.14 48.36 100.14 48.36 115.48 50.17 115.48 53.06 115.48 54.57 115.48 71.56 115.48 88.54 115.48 90.05 115.48 92.93 115.48 94.75 115.48 94.75 100.14 92.93 100.14 92.93 102.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.4,100.27l-.14-15.33H54.84l-.13,15.33h3V93.22c0-2.16,3.66-6.06,3.66-6.06S65,91.05,65,93.22v7.05h2.91V93.22c0-2.16,3.67-6.06,3.67-6.06s3.66,3.89,3.66,6.06v7.05h2.91V93.22c0-2.16,3.66-6.06,3.66-6.06s3.66,3.89,3.66,6.06v7.05Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.56 117.27 54.55 117.27 54.32 138.38 88.79 138.38 88.55 117.27 71.56 117.27"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.98 56.71 71.56 56.71 55.13 56.71 48.36 60.05 48.36 62.61 53.36 62.61 55.04 62.61 71.56 62.61 88.07 62.61 89.75 62.61 94.75 62.61 94.75 60.05 87.98 56.71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.09,64.5H55L54.9,78.59H88.21ZM71.56,76.94a5.39,5.39,0,1,1,5.39-5.39A5.39,5.39,0,0,1,71.56,76.94Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.03 71.77 71.55 67.12 72.08 71.34 73.81 73.82 71.03 71.77 71.03 71.77 71.03 71.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9bc38e2332af739dbc835410d99b032.svg";
export { ForwardRef as ReactComponent };